import React from 'react';
import Link from "gatsby-link";
import styles from './button.module.scss';


class Button extends React.Component {
  chooseElement () {
    switch (this.props.type) {
      case 'href':
        return React.createElement('a', {className: styles.button, href: this.props.to}, this.props.children);
      case 'submit':
        return React.createElement('button', {className: styles.button, to: this.props.to}, this.props.children);
      default:
        return <Link to={this.props.to} className={styles.button}>{this.props.children}</Link>
    }
  }

  render () {
    return (
      this.chooseElement()
    )
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js